import React, { useEffect, useCallback, FC } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { selectorToasts } from 'store/entities/notification/selectors';
import { removeNotification } from 'store/entities/notification/slice';

import closeIcon from 'assets/images/close.svg';

import './Notifications.scss';

const Notifications: FC = () => {
  const dispatch = useDispatch();
  const toasts = useSelector(selectorToasts);
  const position = 'top-center';

  const removeToast = useCallback(
    (id: number) => {
      dispatch(removeNotification(id));
    },
    [dispatch]
  );

  useEffect(() => {
    const interval = setInterval(() => {
      if (toasts.length) {
        removeToast(toasts[0].id);
      }
    }, 4000);

    return () => {
      clearInterval(interval);
    };
  }, [toasts, removeToast]);

  return (
    <div className={`notification-container ${position}`}>
      {toasts.map((toast, i) => (
        <div key={i} className={`notification toast ${toast.type}`}>
          <p className="notification-image"></p>
          <p className="notification-message">{toast.msg}</p>
          <div className="notification-button" onClick={() => removeToast(toast.id)}>
            <img src={closeIcon} alt="close" />
          </div>
        </div>
      ))}
    </div>
  );
};

export default Notifications;
